export const getApiBaseUrl = () => {
    let url = process.env.REACT_APP_IMG_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';
    // Remove trailing slashes and trailing /api
    url = url.replace(/\/api\/?$/, '').replace(/\/+$/, '');
    return url;
};

export const formatImageUrl = (input, fallback = '/assets/images/thumbs/product-img1.png') => {
    if (!input) return fallback;

    let val = input;
    for (let i = 0; i < 5; i++) {
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (
                (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
                (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
                (trimmed.startsWith('"') && trimmed.endsWith('"'))
            ) {
                try {
                    const parsed = JSON.parse(trimmed);
                    if (parsed !== val) {
                        val = parsed;
                        continue;
                    }
                } catch (e) { }
            }
            break;
        } else if (Array.isArray(val)) {
            val = val.length > 0 ? val[0] : null;
        } else if (val && typeof val === 'object') {
            val = Object.values(val)[0] || null;
        } else {
            break;
        }
    }

    if (!val || typeof val !== 'string') return fallback;
    let url = val.trim().replace(/^["'[\]\s]+/, '').replace(/["'[\]\s]+$/, '');
    if (!url) return fallback;

    // Fix single slash typos like https:/ or http:/
    if (/^https?:\/[^/]/i.test(url)) {
        url = url.replace(/^(https?):\/+/, '$1://');
    }

    // If it's a frontend public asset (e.g. assets/images/... or /assets/images/...)
    if (url.startsWith('/assets/') || url.startsWith('assets/')) {
        return `/${url.replace(/^\//, '')}`;
    }

    // Data URI or blob URI
    if (url.startsWith('data:') || url.startsWith('blob:')) {
        return url;
    }

    const API_BASE = getApiBaseUrl();

    // Check if it contains an uploads path (e.g. from frontend domain, localhost, or any server)
    if (url.includes('/uploads/')) {
        const afterUploads = url.split('/uploads/').pop();
        const clean = afterUploads.replace(/^\/+/, '');
        return `${API_BASE}/uploads/${clean}`;
    }

    // If it starts with uploads/ or /uploads/
    if (/^\/?uploads\//i.test(url)) {
        const clean = url.replace(/^\/?uploads\//i, '');
        return `${API_BASE}/uploads/${clean}`;
    }

    // If it's a full external URL (like cloudinary, s3, etc.) that does NOT contain /uploads/
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }

    // Otherwise, treat as an uploaded file or relative backend asset
    const clean = url.replace(/^\/+/, '');
    return `${API_BASE}/uploads/${clean}`;
};


